angular.module('elfium').controller('userController', ['$scope', '$window', 'elfiumLoginService', 'userService', 'elfiumToastrService', 'ELFIUM_USER_TYPES',
    function ($scope, $window, elfiumLoginService, userService, elfiumToastrService, ELFIUM_USER_TYPES) {
        var that = this;
        $scope.clickedButton = false;
        $scope.userTypes = ELFIUM_USER_TYPES;
        $scope.formFields = {
            type: ELFIUM_USER_TYPES.CONSULTANT
        };
        that.init = function () {
            that.getUsers();
        };
        that.redirectToDashboard = function () {
        	$window.location = '#/dashboard';
        };
        that.sendLoginRequest = function (email, password) {
            elfiumLoginService.sendLoginRequest(email, password).then(function (loginMessage) {
                elfiumToastrService.success(loginMessage);
                that.redirectToDashboard();
            }, elfiumToastrService.error);
        };
        that.getUsers = function () {
            userService.getUsers().then(function (users) {
                $scope.users = users;
            }, elfiumToastrService.error);
        };
        that.sendRegistrationRequest = function (type, name, nameShort, email, password) {
            elfiumLoginService.sendRegistrationRequest(type, name, nameShort, email, password).then(function (loginMessage) {
                elfiumToastrService.success(loginMessage);
                that.redirectToDashboard();
            }, elfiumToastrService.error);
        };
        $scope.login = function ($event) {
            $event.stopPropagation();
            $scope.clickedButton = true;
            if ($scope.loginForm.$valid) {
                that.sendLoginRequest($scope.formFields.username, $scope.formFields.password);
            }
        };
        $scope.register = function ($event) {
            $event.stopPropagation();
            $event.preventDefault();
            $scope.clickedButton = true;
            if ($scope.loginForm.$valid) {
                that.sendRegistrationRequest($scope.formFields.type, $scope.formFields.name, $scope.formFields.nameShort, $scope.formFields.username, $scope.formFields.password);
            }
        };
        $scope.openUserDetailModal = function (userId) {
            userService.openUserDetailModal(userId).then(that.getUsers);
        };
        $scope.getInputClass = function (inputName) {
            if ($scope.clickedButton && $scope.loginForm && $scope.loginForm[inputName].$invalid) {
                return 'has-error';
            }
        };
        that.init();
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/user/userController.ts